import React from "react"
import { Chip, IconButton, FontIcon } from "material-ui"
import strings from "../../../localization/strings"
import autobind from "class-autobind"
import { IUnitItem } from "../../../models"
import AddScheduleBudgetUnitDialog from "./AddScheduleBudgetUnitDialog"
import _ from "lodash"
interface IProps {
    readonly: boolean
    budgetUnits: IUnitItem[]
    handleUpdate(budgetUnits: IUnitItem[]): void
}

interface IState {
    openAddBudgetUnitDialog: boolean
}

export default class ScheduleBudgetUnits extends React.Component<IProps, IState>  {
    constructor(props: IProps) {
        super(props)
        this.state = {
            openAddBudgetUnitDialog: false
        }
        autobind(this)
    }

    render() {
        return (
            <div style={{ minHeight: 75 }}>
                <div style={{ fontSize: 14, fontWeight: "bold" }}>
                    {strings.Budget_Units}
                </div>
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {this.props.budgetUnits.length > 0 ?
                        this.props.budgetUnits.map(i =>
                            <Chip
                                key={i.Id}
                                style={{ margin: 2, height: 35, width: "min-content" }}
                                onRequestDelete={this.props.readonly ?
                                    null :
                                    () => {
                                        const budgetUnits = _.cloneDeep(this.props.budgetUnits)
                                        budgetUnits.splice(budgetUnits.indexOf(i), 1)
                                        this.props.handleUpdate(budgetUnits)
                                    }
                                }
                            >
                                {i.Name}
                            </Chip>
                        ) :
                        this.props.readonly &&
                        <div style={{ marginTop: 5, marginLeft: 10 }}>{strings.There_is_no_Budget_Unit_item}</div>
                    }
                    {!this.props.readonly &&
                        <IconButton
                            data-intercom-target={"Client-Btn-OpenClientSelectionDialog"}
                            style={{ height: 35, width: 35, padding: 0, margin: 0, display: "inline-block" }}
                            onTouchTap={() => { this.setState({ openAddBudgetUnitDialog: true }) }}
                        >
                            <FontIcon className="fa fa-plus-circle" />
                        </IconButton>
                    }
                </div>
                {this.state.openAddBudgetUnitDialog &&
                    <AddScheduleBudgetUnitDialog
                        handleAdd={budgetUnit => {
                            const budgetUnits = _.cloneDeep(this.props.budgetUnits)
                            budgetUnits.push(budgetUnit)
                            this.setState({ openAddBudgetUnitDialog: false }, () => this.props.handleUpdate(budgetUnits))
                        }}
                        handleClose={() => this.setState({ openAddBudgetUnitDialog: false })}
                    />
                }
            </div>
        )
    }
}